import { render, staticRenderFns } from "./DoubleInfoBlock.vue?vue&type=template&id=fb20a494&"
import script from "./DoubleInfoBlock.vue?vue&type=script&lang=js&"
export * from "./DoubleInfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./DoubleInfoBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports